module.exports = __webpack_public_path__ + "static/media/residuos.bf661118.webp";